import { RootState } from "@/redux/store";

export const userAccountsSelector = (state: RootState) => state.userAccount.account.items;
export const userAccountsPageSelector = (state: RootState) => state.userAccount.account.page;

export const userAccountHistorySelector = (state: RootState) => state.userAccount.accountHistory.items;
export const userAccountHistoryPageSelector = (state: RootState) => state.userAccount.accountHistory.page;
